import BASE from "./en.json";
export const EN = {
  ...BASE,
};
